// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3370":"085d89c76f8c6ffb","9973":"b68837ecfa25a30d"}[chunkId] + ".css";
};